<template>
  <div id="w2c_chat" class="chat_container">
    <div v-if="chatActivated" class="">
<!--      <div v-if="loaded">-->
        <div v-if="discussion.error">{{ discussion.error }}</div>
        <ChatStart v-else></ChatStart>
<!--      </div>-->
      <!--    <i v-else class="fa fa-spinner"></i>-->
    </div>
    <div v-else>
      <button @click="activateChat" class="chat_btn" :style="{ background: this.$store.state.color, color: this.$store.state.text_color }">
        <span v-if="$store.state.user_is_live" class="w2c_dot" style="height: 12px; width: 12px; background-color: #0bee0b; margin-right: 7px; border-radius: 50%; display: inline-block;  box-shadow: 1px 1px 5px rgba(255,255,255,0.7); margin-left: -7px;"></span>Chat</button>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import store from "./chat_store";
export default {
  methods: {
    activateChat() {
      this.$store.state.chatActivated = true
      if (localStorage.getItem('chat_id')) {
        store.dispatch('loadMessages', localStorage.getItem('chat_id'))
      }
    }
  },

  computed: {
    ...mapFields([
      'chatActivated',
      'chatEnded'
    ]),
    discussion() {
      return this.$store.state.discussion
    },
    loaded() {
      return !this.$store.state.loading
    }
  }
}
</script>

<style scoped>
.chat_container {
  position: fixed;
  bottom: 0;
  right: 25px;
  z-index: 9999;
}
p {
  font-size: 2em;
  text-align: center;
}
.chat_btn {
  padding: 10px 20px;
  border: none;
  border-radius: 10px;
  margin-bottom: 25px;
  cursor: pointer;
  font-weight: bold !important;
  box-shadow: 1px 1px 20px rgba(0,0,0,0.1);
}
</style>
